import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { H4 } from '@ui/blocks/Heading'

interface FooterMenuLink {
  id: string
  title: string
  url: string
  externalLink?: string
}

interface Props {
  title: string
  links: FooterMenuLink[]
}

const MenuGroupContainer = styled.div`
  :not(:first-child) {
    margin-top: 4rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    :not(:first-child) {
      margin-top: 2.6rem;
    }
  }
`

const MenuGroupTitle = styled(H4)`
  margin-bottom: 2.4rem;
  color: ${({ theme }) => `${theme.global.colors.white}`};
  line-height: 4rem;
  font-style: normal;

  @media ${({ theme }) => theme.device.tablet} {
    line-height: 4rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-bottom: 1.6rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }
`

const MenuItem = styled.li`
  margin: 0;
`

const MenuLink = styled(Link)`
  display: inline-block;
  font-size: 1.5rem;
  line-height: 3.7rem;
  color: ${({ theme }) => `${theme.global.colors.white}`};

  :hover {
    color: ${({ theme }) => `${theme.global.colors.shadowGreen}`};
  }

  :active {
    color: ${({ theme }) => `${theme.global.colors.white}`};
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0;
    font-size: 1.5rem;
    line-height: 3.7rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 1.2rem;
    line-height: 3rem;
  }
`

const FooterMenuGroup = ({ title, links }: Props) => {
  return (
    <MenuGroupContainer>
      <MenuGroupTitle>{title}</MenuGroupTitle>
      <ul>
        {links.map(({ id, title, url, externalLink }) => {
          return (
            <MenuItem key={id}>
              {externalLink ? (
                <MenuLink as="a" rel="nofollow noopener" href={externalLink} target="_blank">
                  {title}
                </MenuLink>
              ) : (
                <MenuLink to={url}>{title}</MenuLink>
              )}
            </MenuItem>
          )
        })}
      </ul>
    </MenuGroupContainer>
  )
}

export default FooterMenuGroup
